import React, { createContext, useContext, useEffect, useState } from "react";
import { getCustomerSession, saveCustomerSession, clearCustomerSession } from "../lib/api";

const AuthCtx = createContext(null);

const sessionUser = () => {
  const s = getCustomerSession();
  return s ? { id: s.id, name: s.name } : null;
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(sessionUser);

  useEffect(() => {
    const onUnauth = () => setUser(null);
    window.addEventListener("dd:customer-unauth", onUnauth);
    const t = setInterval(() => setUser(sessionUser()), 60000);
    return () => {
      window.removeEventListener("dd:customer-unauth", onUnauth);
      clearInterval(t);
    };
  }, []);

  const login = (token, userData) => {
    saveCustomerSession(token, userData);
    setUser(userData);
  };

  const logout = () => {
    clearCustomerSession();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading: false, login, logout, hasPubSession: () => !!getCustomerSession() }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
